{
  "availability": "Monday to Friday<br>Amsterdam: 08:30 to 22:00<br>New York: 6:00AM to 7:00PM",
  "facebook_messenger": "Facebook Messenger",
  "inselhuepfen": {
    "availability": "We are available from Monday to Friday 9am to 12pm and 2pm to 5pm",
    "faqs": "Our FAQs",
    "faqs_url": "https://www.inselhuepfen.com/en/good-to-know",
    "phone_numbers": "+49 (0) 7531 / 361860",
    "send_us_a_message_url": "https://www.inselhuepfen.com/en/contact",
    "title": "Any questions?"
  },
  "kootstra": {
    "availability": "Our opening hours:<br>\nMonday – Friday<br>\n9:00 – 17:00 hrs",
    "email_address": "reisen@kootstra.de",
    "email_us": "Send us an email",
    "phone_availability": "9:00-11:00 and 13:00-16:00 hrs",
    "phone_numbers": "+49 (0) 251-518161",
    "title": "Do you have questions?"
  },
  "phone_numbers": "+31 20 72 35 400 (NL);+1 203 814 1249 (USA)",
  "send_us_a_message": "Send us a message",
  "send_us_a_message_url": "https://www.boatbiketours.com/contact/#contact_form",
  "start_a_live_chat": "Start a live chat",
  "title": "Questions?"
}
